import React from 'react'
import { Row, Col } from 'react-bootstrap'
import RecordPagination from '../../common/pagination'
import SpinnerContainer from '../../common/spinner-container'

const MessagesListPaginated = ({
    isLoading,
    messages,
    offset,
    limit = 10,
    total,
    onOffsetChange = () => {},
    onMessagesUpdate = () => {},
    messageComponent
}) => {
    const renderMessage = (message, key) => {
        const MessageComponent = messageComponent
        return (
            <MessageComponent
                key={key}
                message={message}
            />
        )
    }
    return (
        <React.Fragment>
            {isLoading && <Row><Col className='text-center'><SpinnerContainer /></Col></Row>}
            <Row>
                {messages.map(renderMessage)}
                {total===0 && !isLoading && <Col className='text-muted text-center'>There are no messages.</Col>}
            </Row>
            <Row>
                <Col>
                    <RecordPagination offset={offset} limit={limit} total={total} setOffset={onOffsetChange} />
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default MessagesListPaginated